<template>
<div v-on:click="closeMenu()" >
  <headlink v-if="parent == '0'" ></headlink>
  <headlink1 v-if="parent == '1'" ></headlink1>
  <div class="container ui-flex ui-flex-pack-center">
        	<div class="left-container ui-border-l" style="background-color: #3FB5FF;">
        		<div class="head-top" >
        			<img src="img/icon13.png"  /> 
        			<div class="title" >4路远程控制设备 </div>
        			<p class="subtitle" >离线</p>
        		</div>
				<div class="ui-flex ui-flex-pack-center mass-center" style="height: auto;" >
				    <div>
				    	<img onmousedown="change1(this)" onmouseup="change2(this)" src="img/anniu_4_l_a.png" class="pointer" width="300px" />	
				    </div>
				    
				</div>
				<div class="mass-center" >
			    	<div class="ui-form-item ui-form-item-switch">
			    		<label class="ui-switch" style="right: 300px;" >
			                <input type="checkbox">
			            </label>
		    		</div>
		    		<p class="align-p" >自锁模式</p>
		    	</div>
				<div class="mass-center" >
					<div class="mass-title" >005秒</div>
					<div class="mass-img"> <img src="img/shezhi_2_h.png" /> </div>
				</div>
				
        	</div>
        	<div class="right-container bluegack"  >
        		<div class="search" results="s" >
        			<input class="" />
        			<i class="ui-icon-search white" ></i>
        		</div>
        		<ul class="shuru-list-right ui-list ui-list-function">
				    <li class="border-bule-b">
				        <div class="ui-row-flex">
						    <div class="ui-col tc"><img src="img/icon17.png" /></div>
						    <div class="ui-col ui-col-2 ui-row-flex ui-row-flex-ver">
						    	<div class="ui-col text1">四路控制器1</div>
							    <div class="ui-col text2"><img src="img/icon20.png" /> 断电带记忆</div>
						    </div>
						</div>
				    </li>
				    <li class="border-bule-b">
				        <div class="ui-row-flex">
						    <div class="ui-col tc"><img src="img/icon16.png" /></div>
						    <div class="ui-col ui-col-2 ui-row-flex ui-row-flex-ver">
						    	<div class="ui-col text1">四路控制器1</div>
							    <div class="ui-col text2"><img src="img/icon21.png" /> 断电带记忆</div>
						    </div>
						</div>
				    </li>
				    <li class="border-bule-b">
				    	<div class="ui-row-flex">
						    <div class="ui-col " ><img src="img/icon17.png" /></div>
						    <div class="ui-col ui-col-2 ui-row-flex ui-row-flex-ver">
						    	<div class="ui-col text1">四路控制器1</div>
							    <div class="ui-col text2"><img src="img/icon20.png" /> 断电带记忆</div>
						    </div>
						</div>
				    </li>
				</ul>	
        	</div>
        </div>



			<div class="alert right-click"  v-show="alert5" v-if="parent == '0'" >
				<div class="dialog right-click-dialog" >
					<ul>
						<li v-on:click="showEq()" >修改设备名称</li>
						<li v-on:click="removeEq()" >删除此设备</li>
						<li v-on:click="showEqDdjy()" >掉电记忆设置</li>
						<router-link :to="{ name:'ditu', params: {eqId:leftEq.eqId } }"> <li v-if="leftEq.eqType ==5 || leftEq.eqType ==6" >显示位置</li></router-link>
				   	<router-link :to="{ name:'dingshi', params: {eqId:leftEq.eqId,eqType:leftEq.eqType} }"> <li v-if="leftEq.eqType ==8 || leftEq.eqType ==9 || leftEq.eqType ==10" >定时设置</li></router-link>
						<router-link :to="{ name:'port', params: {eqId:leftEq.eqId,eqType:leftEq.eqType } }"> <li v-if="leftEq.eqType !=3 || leftEq.eqType !=6" >端口报警提示设置</li></router-link>
						<router-link :to="{ name:'port1', params: {eqId:leftEq.eqId } }"> <li>停电来电报警设置</li></router-link>
					</ul>
				</div>
		</div>

		<div class="alert" v-show="alert1" >
    	<div class="dialog" >
    		<div><input class="input-type"  v-model="citName" placeholder="电路名称"  /> </div>
    		<div style="padding: 20px;padding-bottom: 0; text-align: center;" ><button class="btn-type" v-on:click="setName()" >确定</button><button class="btn-type btn-close" v-on:click="closeShow(1)" >取消</button></div>
    	</div>
	</div>
		<div class="alert" v-show="alert6" >
				<div class="dialog" >
					<div><input class="input-type"  v-model="alertEqName" placeholder="设备名称"  /> </div>
					<div style="padding: 20px;padding-bottom: 0; text-align: center;" ><button class="btn-type" v-on:click="setEqName()" >确定</button><button class="btn-type btn-close" v-on:click="closeShow(6)" >取消</button></div>
				</div>
		</div>
	<div class="alert" v-show="alert2" >
    	<div class="dialog" style="padding: 0;" >
    		<div class="ui-form ">
			        <div class="ui-form-item ui-form-item-switch">
			            <div style="color: #F9A81B;padding-left: 20px;" >
		              		 断电记忆
			            </div>
			            <label class="ui-switch">
			                <input type="checkbox" v-model="eqDdjy" >
			            </label>
			        </div>
			        <div class="ui-form-item ui-border-t" style="text-align: center;">
			        	<div  style="float: left;width: 49%;color: #3FB5FF;border-right:1px solid #e0e0e0;" class="pointer" v-on:click="setEqDdjy()" >确定</div>
			        	<div style="float: right;width: 50%;color: #3FB5FF;" class="btn-close pointer" v-on:click="closeShow(2)">取消</div>
		        	</div>
			</div>
    	</div>
	</div>
	<div class="alert" v-show="alert3" >
    	<div class="dialog" >
    		<div style="text-align:center;color:red;" >{{msg}} </div>
    	</div>
	</div>
	<div class="alert" v-show="alert4" >
    	<div class="dialog" >
    		<div><input id="citDdTime" v-model="citDdTime" class="input-type" placeholder="电动时间" /> </div>
    		<div style="padding: 20px;padding-bottom: 0; text-align: center;" ><button class="btn-type" v-on:click="setTime()" >确定</button><button class="btn-type btn-close" v-on:click="closeShow(4)" >取消</button></div>
    	</div>
	</div>
</div>
</template>
<script>
	
	
import headlink from '@/components/common/headlink'
import headlink1 from '@/components/common/headlink1'

export default {
  name: 'devicemanage',
  data () {
    return {
      eqList:[],
			eqId:"",
			eqName:"",
			eqObject:{},
			list1:[],
			list2:[],
			eqType:"",
			alert1:false,
			alert2:false,
			alert3:false,
			alert4:false,
			alert5:false,
			alert6:false,
			msg:"",
			citObj:{},
			citDdTime:"",
			citName:"",
			leftEq:{},
			alertEqName:"",
			eqDdjy:false,
			parent:"0"
    }
  },
  
      
	methods:{
		setEqDdjy:function(){
			this.alert2 = false;
			var self = this;
			const history = window.sessionStorage;
			var uid = history.getItem("user");
			this.$http.post('/ZYun/HttpService.do', {
				"serviceCode":"1017",
				"uId":"D62A554C0FA943BEA345749DD4EA078E",
				eqId:this.leftEq.eqId,
				ddjyFlag:this.eqDdjy
			})
				.then((response) => {
					if(response.data.respCode=="0000"){
						self.msg = "操作成功";
						self.alert3 = true;
							window.setTimeout(function(){
							self.alert3 = false;
						},1000);		
						this.$http.post('/ZYun/HttpService.do', {
							"serviceCode":"1012",
							"uId":"D62A554C0FA943BEA345749DD4EA078E"
						})
							.then((response) => {
								if(response.data.respCode=="0000"){
									this.eqList = response.data.eqList;
									this.eqId = this.eqList[0].eqId;
									this.clickEq(this.eqList[0]);
								}else{
									console.log(response);
								}
							})
							.catch((response) =>{
								console.log(response);
							});
					}else{
						self.msg = "操作失败";
						self.alert3 = true;
							window.setTimeout(function(){
							self.alert3 = false;
						},1000);
						console.log(response);
					}
				})
				.catch((response) =>{
					console.log(response);
				});
		},
		showEqDdjy:function(){
			this.alert2 = true;
			if(this.leftEq.eqDdjy == "0"){
				this.eqDdjy = false;
			}
			if(this.leftEq.eqDdjy == "1"){
				this.eqDdjy = true;
			}
	},
		setEqName:function(){
			this.alert6 = false;
			var self = this;
			const history = window.sessionStorage;
			var uid = history.getItem("user");
			this.$http.post('/ZYun/HttpService.do', {
				"serviceCode":"1017",
				"uId":"D62A554C0FA943BEA345749DD4EA078E",
				eqId:this.leftEq.eqId,
				eqName:this.alertEqName
			})
				.then((response) => {
					if(response.data.respCode=="0000"){
						self.msg = "操作成功";
						self.alert3 = true;
							window.setTimeout(function(){
							self.alert3 = false;
						},1000);		
						this.$http.post('/ZYun/HttpService.do', {
							"serviceCode":"1012",
							"uId":"D62A554C0FA943BEA345749DD4EA078E"
						})
							.then((response) => {
								if(response.data.respCode=="0000"){
									this.eqList = response.data.eqList;
									this.eqId = this.eqList[0].eqId;
									this.clickEq(this.eqList[0]);
								}else{
									console.log(response);
								}
							})
							.catch((response) =>{
								console.log(response);
							});
					}else{
						self.msg = "操作失败";
						self.alert3 = true;
							window.setTimeout(function(){
							self.alert3 = false;
						},1000);
						console.log(response);
					}
				})
				.catch((response) =>{
					console.log(response);
				});
		},
		showEq:function(){
			this.alertEqName = "";
			this.alert6 = true;
		},
		removeEq:function(){
			var self = this;
			const history = window.sessionStorage;
			var uid = history.getItem("user");
			this.$http.post('/ZYun/HttpService.do', {
				"serviceCode":"1010",
				"uId":"D62A554C0FA943BEA345749DD4EA078E",
				eqId:this.leftEq.eqId
			})
				.then((response) => {
					if(response.data.respCode=="0000"){
						self.msg = "操作成功";
						self.alert3 = true;
							window.setTimeout(function(){
							self.alert3 = false;
						},1000);		
					}else{
						self.msg = "操作失败";
						self.alert3 = true;
							window.setTimeout(function(){
							self.alert3 = false;
						},1000);
						console.log(response);
					}
				})
				.catch((response) =>{
					console.log(response);
				});
		},
		closeMenu:function(){
			this.alert5 = false;
		},
		showMenu:function(obj,event){
			this.leftEq = obj;
			this.alert5 = true;
			$(".right-click").offset({top:event.screenY-150,left:event.screenX})
		},
		setName:function(){
			this.alert1 = false;
			this.updateEq(this.citObj,1,this.citName);
			this.citName = "";
	},
		showName:function(obj){
			this.citObj = obj;
			this.alert1 = true;
		},
		refurbish:function(){
			const history = window.sessionStorage;
			var uid = history.getItem("user");
			this.$http.post('/ZYun/HttpService.do', {
				"serviceCode":"1021",
				"uId":"D62A554C0FA943BEA345749DD4EA078E",
				eqId:this.eqId
			})
				.then((response) => {
					if(response.data.respCode=="0000"){
						this.eqObject = response.data;
						this.eqType = response.data.eqType;
						for (var cit of this.eqObject.citList) {
							var word1 = cit.citType.substring(0,1);
							var word2 = cit.citType.substring(1,2);
							var i = parseInt(word2)-1;
							if(word1 == "0"){
								this.list1[i] = cit;
							}else{
								this.list2[i] = cit;
							}
						}
					}else{
						console.log(response);
					}
				})
				.catch((response) =>{
					console.log(response);
				});
		},
		closeShow(obj){
			if(obj == "1"){
				this.alert1 = false;
			}
			if(obj == "2"){
				this.alert2 = false;
			}
			if(obj == "3"){
				this.alert3 = false;
			}
			if(obj == "4"){
				this.alert4 = false;
			}
			if(obj == "5"){
				this.alert5 = false;
			}
			if(obj == "6"){
				this.alert6 = false;
			}
		},
		setTime:function(){
			var self = this;
			var re = /^[1-9]+[0-9]*]*$/;
			if (!re.test(this.citDdTime)) {
				this.alert4 = false;
				self.msg = "请输入数字";
				self.alert3 = true;
					window.setTimeout(function(){
					self.alert3 = false;
				},1000);
　　　　return ;
　　	}
			this.citObj.citDdTime = this.citDdTime;
			this.alert4 = false;
		},
		showTime:function(obj){
			this.citDdTime = "";
			this.alert4 = true;
			this.citObj = obj;
		},
		pad:function(num, n) {  
    var len = num.toString().length;  
    while(len < n) {  
        num = "0" + num;  
        len++;  
    }  
    return num;  
		},
		clickEq(eq){
			$("#"+eq.eqId).addClass("list-active");
			this.eqId = eq.eqId;
			this.eqName = eq.eqName;
			const history = window.sessionStorage;
			var eqId = history.setItem("eqId",this.eqId);
			var uid = history.getItem("user");
			this.$http.post('/ZYun/HttpService.do', {
				"serviceCode":"1018",
				"uId":"D62A554C0FA943BEA345749DD4EA078E",
				eqId:this.eqId
			})
				.then((response) => {
					if(response.data.respCode=="0000"){
						this.eqObject = response.data;
						this.eqType = response.data.eqType;
						for (var cit of this.eqObject.citList) {
							var word1 = cit.citType.substring(0,1);
							var word2 = cit.citType.substring(1,2);
							var i = parseInt(word2)-1;
							if(word1 == "0"){
								this.list1[i] = cit;
							}else{
								this.list2[i] = cit;
							}
						}
					}else{
						console.log(response);
					}
				})
				.catch((response) =>{
					console.log(response);
				});
		},
		open:function(){
			var self = this;
			const history = window.sessionStorage;
			var uid = history.getItem("user");
			this.$http.post('/ZYun/HttpService.do', {
				"serviceCode":"1020",
				"uId":"D62A554C0FA943BEA345749DD4EA078E",
				eqId:this.eqId,
				citState:"1"
			})
				.then((response) => {
					if(response.data.respCode=="0000"){
						self.msg = "设备全开成功";
						self.alert3 = true;
						 window.setTimeout(function(){
              self.alert3 = false;
            },1000);
					}else{
						self.msg = "设备全开失败";
						self.alert3 = true;
						 window.setTimeout(function(){
              self.alert3 = false;
            },1000);
						console.log(response);
					}
				})
				.catch((response) =>{
					console.log(response);
				});
		},
		close:function(){
			var self = this;
			const history = window.sessionStorage;
			var uid = history.getItem("user");
			this.$http.post('/ZYun/HttpService.do', {
				"serviceCode":"1020",
				"uId":"D62A554C0FA943BEA345749DD4EA078E",
				eqId:this.eqId,
				citState:"1"
			})
				.then((response) => {
					if(response.data.respCode=="0000"){
						self.msg = "设备全关成功";
						self.alert3 = true;
						 window.setTimeout(function(){
              self.alert3 = false;
            },1000);
					}else{
						self.msg = "设备全关失败";
						self.alert3 = true;
						 window.setTimeout(function(){
              self.alert3 = false;
            },1000);
						console.log(response);
					}
				})
				.catch((response) =>{
					console.log(response);
				});
		},
		updateEq:function(obj,type,value){
			var self = this;
			const history = window.sessionStorage;
			var uid = history.getItem("user");
			var data = {};
			if(type == 1){
				data = {
					"serviceCode":"1019",
					"uId":"D62A554C0FA943BEA345749DD4EA078E",
					eqId:this.eqId,
					citId:obj.citId,
					citName:value
				}
			}
			console.log(obj.citDdTime)
			if(type == 2){
				data = {
					"serviceCode":"1019",
					"uId":"D62A554C0FA943BEA345749DD4EA078E",
					eqId:this.eqId,
					citId:obj.citId,
					citState:value,
					citDdTime:obj.citDdTime
				}
			}
			this.$http.post('/ZYun/HttpService.do', data)
				.then((response) => {
					if(response.data.respCode=="0000"){
						self.msg = "操作成功";
						self.alert3 = true;
						 window.setTimeout(function(){
              self.alert3 = false;
            },1000);
						this.clickEq(this.eqObject);
					}else{
						self.msg = "操作失败";
						self.alert3 = true;
						 window.setTimeout(function(){
              self.alert3 = false;
            },1000);
						console.log(response);
					}
				})
				.catch((response) =>{
					console.log(response);
				});
		}
	},
  mounted: function () {
    const history = window.sessionStorage;
    var uid = history.getItem("user");
	var parent = history.getItem("parent");
	this.parent = parent;
	console.log("-------------"+parent)
    this.$http.post('/ZYun/HttpService.do', {
      "serviceCode":"1012",
      "uId":"D62A554C0FA943BEA345749DD4EA078E"
    })
      .then((response) => {
        if(response.data.respCode=="0000"){
          this.eqList = response.data.eqList;
					this.eqId = this.eqList[0].eqId;
					this.clickEq(this.eqList[0]);
        }else{
          console.log(response);
        }
      })
      .catch((response) =>{
        console.log(response);
      });
  },
  components: {
    headlink:headlink,
	headlink1:headlink1
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped src="../../../static/css/mass.css">
.list-active{
	background-color: #0101FE;
}
</style>



// WEBPACK FOOTER //
// src/components/devicemanage/devicemanage2.vue